
import { defineComponent, inject, ref, computed, provide } from 'vue'
import axios from "axios";
import { useStore } from "vuex";
//icons
import { Search, ArrowLeft } from '@element-plus/icons-vue'
import type { TabPaneName, TabsPaneContext, TableInstance } from 'element-plus'
//components
import MixedWidget14 from "@/components/widgets/mixed/Widget14.vue";
import MixedWidget16 from "@/components/widgets/mixed/Widget16.vue";
import MixedWidget17 from "@/components/widgets/mixed/Widget17.vue";
import MixedWidget18 from "@/components/widgets/mixed/Widget18.vue";
import ModalSelectPerson from "@/components/modals/general/ModalListPersons.vue";
import ModalRegister from "./ModalRegister.vue"
import ModalTest from "@/components/modals/general/ModalTest.vue"
import ModalTeamColor from "./ModalTeamColor.vue"
// import dsCounter from '@/components/widgets/mixed/dsCounter.vue';
import ModalObservaciones from './ModalObservaciones.vue';
import CountDown from "@/components/widgets/mixed/dsCounter.vue"
import ModalItinerario from "./ModalItinerario.vue"
import ModalTeam from '@/components/modals/general/ModalTeam.vue';
import DialogOrderDetail from '@/views/payments/modals/DialogOrderDetail.vue';

//services
import eventService from "@/core/services/EventService";
import AcrdService from '@/core/services/AcrdService';
import GlobalService from '@/core/services/GlobalService';
import { errManager, mbtoa, showNotification, confirmDelete, DownloadFile } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { useI18n } from "vue-i18n/index";
import moment from 'moment';
moment.locale("es");

export default defineComponent({
    props: {
        evento: {
            type: Object,
            required: true,
            default: {}
        },
        sport: {
            type: Object,
            required: true,
            default: {}
        },
        listStatus: {
            type: null,
            required: true,
            default: []
        },
        rowClub: {
            type: Object,
            required: false,
            default: {}
        },
        checkdoc: {
            type: Array,
            required: false,
            default: []
        },
    },
    components: {
        MixedWidget14, MixedWidget16, MixedWidget17, MixedWidget18, ModalSelectPerson, ModalRegister,
        ModalTeamColor, ModalObservaciones, ModalTest, CountDown,
        ModalItinerario, ModalTeam, DialogOrderDetail
    },
    setup(props) {
        let fURL;
        const { t } = useI18n();
        const indexRow = ref(0)
        const singleTableRef = ref<TableInstance>()
        const store = useStore();
        const altura = screen.height - 400;
        const isTerminos = ref(false);
        const REPO = ref(process.env.VUE_APP_REPO);
        const action = ref(0);
        const dialogNominal = inject<boolean>('dialogNominal');
        const dialogTeamColor = ref(false);
        const dialogTerminos = ref(false);
        const listRTRegister = ref<any>([]);
        const listRCheckDoc = ref<any>([]);
        const listRGender = ref<any>([]);
        const listNominal = ref<any>([]);
        const listTeams = ref<any>([]);
        const total = ref(0);
        const loaderGral = ref(false);
        const loaderSumary = ref<any>(false);
        const loaderTable = ref(false);
        const loaderDownload = ref(false);
        const fechaFin = ref<Date | null>(null);
        const multipleSelection = ref<any[]>([]);
        const dialogTeamRef = ref<any>(null);
        const activeTab = ref(null)
        const selectedTab = ref<TabPaneName | null>(null);
        const actionTab = ref<number>(0)
        const DialogOrderDetailRef = ref<any>(null);

        const searchText = ref("");
        const tregister = ref("D");
        const listChecks = ref<any>([]);
        const gblDialogAcrd = ref<any>(false); //modal register
        const gblDialogTest = ref<any>(false);
        const listSetting = ref<any>({}); //lista de configuraciones
        const closure = ref<any>({});
        const repman = ref<any>({})
        const modalItinerarioRef = ref<any>(null);
        //get data sharing
        const gblDialog = inject<any>('gblDialog');
        const gblRowAcrd = inject<any>('gblRowAcrd');
        const dialogObservation = ref(false);
        const rowIdObs = ref<any>('');
        const rowAcrd = ref<any>({});
        const rowSelected = ref<any>({});
        const listSelectedOrder = ref<any[]>([])
        const otherData = ref<any>({});
        //credentiasl
        const dialogCredentials = ref(false);
        const optionCredential = ref(true);
        const loadingCredential = ref(false);

        provide('gblDialogAcrd', gblDialogAcrd);
        provide('gblDialogTest', gblDialogTest);
        provide('dialogTeamColor', dialogTeamColor);
        provide('rowAcrd', rowAcrd);
        provide('dialogObservation', dialogObservation);
        provide('rowIdObs', rowIdObs);

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        //methods
        const onOpened = () => {
            setStatus()
            getSetting()

            //obteniendo información adicional
            if(props.rowClub?.idinstitution){
                getRepman()
            }
        }

        const getSetting = async () => {
            loaderGral.value = true
            await AcrdService.options('setting', { idevent: props.evento.idevent, idsport: props.sport.idsport })
                .then((res) => {
                    loaderGral.value = false
                    listSetting.value = res.data
                    closure.value = res.data.closure
                    fechaFin.value = closure.value.date_end
                    tregister.value = res.data.tregister[0]?.id
                    
                    //validar si contempla registro de equipos
                    if(closure.value.teams>0){
                        getTeams();
                    } else {
                        getSummary()
                        getListNominal()
                    }
                    
                }).catch(({ response }) => {
                    loaderGral.value = false
                    errManager(response)
                })
        }

        const getTeams = async() => {
            loaderGral.value = true
            await GlobalService.post('teams', {
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                idinstitution : props.rowClub?.idinstitution
            })
            .then((res)=>{
                loaderGral.value = false;
                listTeams.value = res.data;
                if(listTeams.value.length>0){
                    if(activeTab.value == null){
                        activeTab.value = res.data[0].idteam
                        selectedTab.value = listTeams.value[0].idteam;
                    }
                    getSummary()
                    getListNominal()
                }
            }).catch(({ response }) => {
                loaderGral.value = false
                errManager(response)
            })
        }

        const setStatus = () => {
            if (listChecks.value.length == 0) {
                listChecks.value.length = 0
                props.listStatus.forEach((element: any) => {
                    listChecks.value.push(element.id)
                });
            }
        }

        const getRepman = async () => {
            repman.value = {}
            await GlobalService.post('repman', {
                idclub: props.rowClub?.idinstitution,
                status: 1
            }).then((res) => {
                repman.value = res.data
            }).catch(({ response }) => {
                errManager(response)
            })
        }

        const onClosed = () => {
            total.value = 0
            listNominal.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            listRTRegister.value = []
            listSetting.value = {}
            listTeams.value = []
            closure.value = {}
            loaderGral.value = false
            activeTab.value = null
            selectedTab.value = null
        }

        //resumen
        const getSummary = async () => {
            loaderSumary.value = true
            listRTRegister.value = []
            listRCheckDoc.value = []
            listRGender.value = []
            total.value = 0
            listRGender.value.slice(0)
            await eventService.summary({
                idevent: props.evento?.idevent,
                idsport: props.sport.idsport,
                idinstitution : props.rowClub?.idinstitution,
                checkdoc: [0, 1, 2, 3, 4]
            })
                .then((res) => {
                    listRTRegister.value = res.data.rtregister
                    listRCheckDoc.value = res.data.rcheckdoc
                    listRGender.value = res.data.rgender
                    listRGender.value.forEach(element => {
                        total.value += parseInt(element.quantity)
                    });
                    loaderSumary.value = false
                }).catch(({ response }) => {
                    loaderSumary.value = false
                    errManager(response)
                })
        }

        const getListNominal = async () => {
            listNominal.value.length = 0
            loaderTable.value = true
            await eventService.getNominal({
                idevent: props.evento.idevent,
                idsport: props.sport.idsport,
                checkdoc: listChecks.value,
                type_register: tregister.value,
                idteam: activeTab.value,
                idinstitution : props.rowClub?.idinstitution
            })
                .then((res) => {
                    listNominal.value = res.data
                    loaderTable.value = false

                    const row = listNominal.value[indexRow.value]
                    if (row) {
                        singleTableRef.value?.setCurrentRow(row)
                    }
                    /*
                    if(indexRow.value && listNominal.value.length>0){
                        singleTableRef.value!.setCurrentRow(rowSelected.value)
                    }
                    */

                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        //filters
        const filteredNominal = computed(() => {
            return listNominal.value.filter(
                (item) =>
                    item.persona.toLowerCase().includes(searchText.value.toLowerCase()) ||
                    item.docnumber.includes(searchText.value.toLowerCase())
            );
        });

        const openModalSelectPersons = () => {
            gblDialog.value = true
        }

        const getSelectRow = (data) => {
            Object.assign(rowAcrd.value, data, { tregister: tregister }, { idevent: props.evento.idevent }, { idsport: props.sport.idsport }, {idteam: activeTab.value})
            action.value = 1
            gblDialogAcrd.value = true
        }

        const OnTest = async (row) => {
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    gblDialogTest.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const onEdit = async (row, accion, index) => {
            indexRow.value = index;
            rowSelected.value = row
            loaderTable.value = true
            await AcrdService.getAcreditation(row.idacreditation, 'show')
                .then((res) => {
                    loaderTable.value = false
                    Object.assign(rowAcrd.value, res.data.info)
                    action.value = accion
                    gblDialogAcrd.value = true
                }).catch(({ response }) => {
                    loaderTable.value = false
                    errManager(response)
                })
        }

        const onDelete = (row) => {
            confirmDelete({
                module: 'acreditation',
                id: row.idacreditation,
                name: `${row.firstname} ${row.lastname}`,
                t,
                onSuccess: resDeleteAcreditation,
                payload: { idacreditation: row.idacreditation }
            });
        }

        //Descargar reportes Excel
        const DownloadXLSXPDF = (ext, target, payload) => {
            loaderDownload.value = true
            let params = new URLSearchParams(payload);
            axios({
                url: process.env.VUE_APP_API_URL + `/${ext}/${target}?${params}`,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileBlob = new Blob([response.data]);
                var contentDisposition = response.headers['content-disposition'];
                var match = /filename="([^"]*)"/.exec(contentDisposition);
                var nameFile = match && match[1] ? match[1] : moment().format() + "." + ext;

                if (!fURL) {
                    fURL = document.createElement('a');
                    fURL.style.display = 'none';
                    document.body.appendChild(fURL);
                }
                var fileURL = window.URL.createObjectURL(fileBlob);
                fURL.href = fileURL;
                fURL.setAttribute('download', nameFile);
                fURL.click();
            }).catch(({response}) => {
                loaderDownload.value = false
                errManager(response)
            }).finally(() => {
                loaderDownload.value = false;
            });
        }

        const sendDataValidation = () => {
            if (multipleSelection.value.length > 0) {
                dialogTerminos.value = true
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    html: "Para solicitar la revisión de información, necesita seleccionar solo los registros cuyos estados sean <b>Borrador</b> u <b>Observado</b>!",
                });
            }
        }

        const handleSelectionChange = (val: any[]) => {
            multipleSelection.value = []
            val.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '0' || item.checkdoc == '4' || item.checkdoc == '3' || item.checkdoc == '1')) {
                    multipleSelection.value.push(item);
                }
            });
        }

        const sendVerification = async () => {
            loaderGral.value = true
            dialogTerminos.value = false
            await AcrdService.options('verification', { 
                idevent: btoa(props.evento.idevent), 
                idsport: btoa(props.sport.idsport), 
                idinstitution: props.rowClub?.idinstitution,
                data: multipleSelection.value })
                .then((res) => {
                    loaderGral.value = false
                    if (res.data.status == 'success') {
                        getSummary()
                        getListNominal()
                    }
                    showNotification({title: res.data.title, message: res.data.message, status: res.data.status})
                }).catch(({ response }) => {
                    loaderGral.value = false
                    errManager(response)
                })
        }

        //metodo de respuesta modal register acrd
        const onResponse = (data) => {
            if (data.status == 'success') {
                getSummary()
                getListNominal()
            }
        }

        const onObservations = (data) => {
            rowIdObs.value = data.idacreditation
            dialogObservation.value = true
        }

        const openItinerario = (data) => {
            if(modalItinerarioRef.value){
                rowSelected.value = data
                modalItinerarioRef.value.openModal();
            }
        }

        const resItinerario = (data) => {
            if(data.status == 'success'){
                getListNominal()
            }
        }

        const openDialogTeam = () =>{
            if(dialogTeamRef.value){
                dialogTeamRef.value.openModal();
            }
        };

        const teamResponse = (data) => {
            if(data.status == 'success'){
                getTeams()
            }
        };

        const onTabClick = (tab: TabsPaneContext) => {
            selectedTab.value = tab.paneName as string;
        };

        const operationTab = (action) => {
            actionTab.value = action;
            openDialogTeam();
        }

        const removeTab = (targetName: TabPaneName) => {
            const objTab = listTeams.value.find((tab) => tab.idteam == targetName) || {};
            confirmDelete({
                module: 'teams',
                id: targetName.toString(),
                name: objTab.name,
                t,
                onSuccess: resDeleteTeam,
                payload: { idinstitution: props.rowClub?.idinstitution }
            });
        };

        const resDeleteTeam = () => {
            activeTab.value = null;
            selectedTab.value = null;
            getTeams();
            getListNominal();
            getSummary();
        }

        const resDeleteAcreditation = () => {
            getListNominal();
            getSummary();
        }

        const generateCredentials = () => {

            let miMultipleSelection = <any>[];
            multipleSelection.value.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '1' || item.checkdoc == '0' || item.checkdoc == '3' || item.checkdoc == '4')) {
                    miMultipleSelection.push(item.idacreditation);
                }
            });

            if (miMultipleSelection.length > 0) {
                DownloadXLSXPDF('pdf', 'credentials', {
                    a: mbtoa(props.evento.idevent),
                    b: mbtoa(props.sport.idsport),
                    c: mbtoa(props.rowClub?.idinstitution),
                    d: miMultipleSelection
                })
            } else {
                showNotification({
                    title: process.env.VUE_APP_NAME,
                    message: 'No se encontrarón registros para generar credenciales',
                    status: 'error',
                });
            }
        };

        const tabChange = () => {
            getListNominal();
            getSummary();
        }

        const handleCurrentChange = (val: any | undefined) => {
            //currentRow.value = val
            //console.log(val)
        }

        const addToOrder = (row: any) => {
            const exists = listSelectedOrder.value.some(
                (item) => item.idacreditation === row.idacreditation
            );
            if (exists) {
                showNotification({title: 'Alerta', message: 'Participante ya existe en la lista.', status:'error'});
            } else {
                listSelectedOrder.value.push(row);
                showNotification({title: 'Bien', message: 'Participante agregado correctamente a la orden.', status:'success'});
               
            }
        }

        const generarOrder = () => {
            if(DialogOrderDetailRef.value){
                otherData.value.idregister = props.evento?.idevent;
                otherData.value.idcountry = props.rowClub?.idcountry;
                otherData.value.customer = props.rowClub?.name;
                DialogOrderDetailRef.value.openModal();
            }
        }

        const deleteItemOrderDetail = (idregister: any) => {
            listSelectedOrder.value = listSelectedOrder.value.filter(
                (item) => item.idacreditation !== idregister
            );
        }

        const onResponseOrderDetails = (data: any) => {
            if(data?.status == 'success'){
                listSelectedOrder.value.splice(0, listSelectedOrder.value.length);
                getListNominal();
            }
        };

        const activeCredential = () => {
            dialogCredentials.value = true
        };

        const sendActiveCredentials = async() => {

            let miMultipleSelection = <any>[];
            multipleSelection.value.forEach(item => {
                if (item.hasOwnProperty('checkdoc') && (item.checkdoc == '1' || item.checkdoc == '0' || item.checkdoc == '4')) {
                    miMultipleSelection.push(item.idacreditation);
                }
            });

            if(miMultipleSelection.length>0){
                loadingCredential.value = true;
                AcrdService.options('actived', {ids: miMultipleSelection, option: optionCredential.value})
                .then((res)=>{
                    loadingCredential.value = false;
                    if(res.data.status == 'success'){
                        dialogCredentials.value = false;
                        getListNominal();
                    }
                    showNotification(res.data)

                }).catch(({response})=>{
                    loadingCredential.value = false;
                    errManager(response);
                });
            }
        };

        const singleAcreditation = (row: any)=>{
            DownloadXLSXPDF('pdf', 'credentials', {
                a: mbtoa(props.evento.idevent),
                b: mbtoa(props.sport.idsport),
                c: mbtoa(props.rowClub?.idinstitution),
                d: [row?.idacreditation]
            })
        };

        const callDownloadFile = (ext: string, target: string, payload: any) => {
            DownloadFile(ext, target, payload, loaderDownload);
        };

        const tableRowClassName  = ({ row }: any) => {
            return row.checkdoc == 4 ? 'bg-light-info text-info border border-info' : '';
        }

        return {
            //dialog
            t,
            REPO,
            mbtoa,
            fechaFin,
            moment,
            altura,
            username,
            isTerminos,
            action,
            dialogNominal,
            dialogTeamColor,
            dialogTerminos,
            dialogTeamRef,
            dialogCredentials,
            optionCredential,
            loadingCredential,
            //more
            gblRowAcrd,
            searchText,
            tregister,
            listChecks,
            closure,
            repman,
            //loaders
            loaderSumary, loaderTable, loaderGral, loaderDownload,
            //icons,
            Search, ArrowLeft,
            //list
            listRTRegister,
            listRCheckDoc,
            listRGender,
            listNominal,
            listTeams,
            listSetting,
            total,
            multipleSelection,
            rowIdObs,
            rowSelected,
            activeTab,
            selectedTab,
            actionTab,
            singleTableRef,
            listSelectedOrder,
            DialogOrderDetailRef,
            otherData,
            
            //methods
            onOpened,
            getSetting,
            onClosed,
            getListNominal,
            filteredNominal,
            openModalSelectPersons,
            getSelectRow,
            onResponse,
            onEdit,
            onDelete,
            DownloadXLSXPDF,
            sendDataValidation,
            handleSelectionChange,
            sendVerification,
            onObservations,
            OnTest,
            openItinerario,
            //referencias
            modalItinerarioRef,
            resItinerario,
            //openDialogTeam,
            teamResponse,
            operationTab,
            removeTab,
            tabChange,
            onTabClick,
            generateCredentials,
            handleCurrentChange,
            addToOrder,
            generarOrder,
            deleteItemOrderDetail,
            onResponseOrderDetails,
            activeCredential,
            sendActiveCredentials,
            singleAcreditation,
            callDownloadFile,
            tableRowClassName
        }

    },
})
